var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("common.alerts.alerts_history") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "4", lg: "2", xl: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter",
                        on: {
                          click: function ($event) {
                            _vm.displayFilter = !_vm.displayFilter
                          },
                        },
                      },
                      [
                        _vm.displayFilter
                          ? _c("i", { staticClass: "fa-light fa-minus" })
                          : _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("filter.fltr")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "4", lg: "2", xl: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter",
                        attrs: { disabled: _vm.activateSpinner },
                        on: {
                          click: function ($event) {
                            return _vm.onRefresh()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-rotate-right fs-14px",
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.rfrsh")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "min-w-100 justify-content-start",
                class: {
                  "filter-item-section": true,
                  "d-none": !_vm.displayFilter,
                },
              },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "filter-item mb-5",
                    attrs: { sm: "6", lg: "3", cols: "12" },
                  },
                  [
                    _c("datetime-picker-custom", {
                      staticClass: "z-1",
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.dateStart,
                      },
                      attrs: {
                        format: "DD/MM/YYYY H:i:s",
                        inputLabel: _vm.$t("common.alerts.date_start"),
                        customInputParentClass: "filter-item-content",
                        customInputClass: "w-100",
                        maxLength: 19,
                        placeholderValue: _vm.$t(
                          "common.datetime_picker_empty_date"
                        ),
                        inputIcon: "fa-solid fa-calendar",
                      },
                      model: {
                        value: _vm.dateStart,
                        callback: function ($$v) {
                          _vm.dateStart = $$v
                        },
                        expression: "dateStart",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "filter-item mb-5",
                    attrs: { sm: "6", lg: "3", cols: "12" },
                  },
                  [
                    _c("datetime-picker-custom", {
                      staticClass: "z-1",
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.dateEnd,
                      },
                      attrs: {
                        format: "DD/MM/YYYY H:i:s",
                        inputLabel: _vm.$t("common.alerts.date_end"),
                        customInputParentClass: "filter-item-content",
                        customInputClass: "w-100",
                        maxLength: 19,
                        placeholderValue: _vm.$t(
                          "common.datetime_picker_empty_date"
                        ),
                        inputIcon: "fa-solid fa-calendar",
                      },
                      model: {
                        value: _vm.dateEnd,
                        callback: function ($$v) {
                          _vm.dateEnd = $$v
                        },
                        expression: "dateEnd",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "filter-item mb-5",
                    attrs: { sm: "6", lg: "3", cols: "12" },
                  },
                  [
                    _c(
                      "label",
                      { attrs: { for: "alert-select-criticality" } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.alerts.criticality_level")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.criticality,
                            expression: "criticality",
                          },
                        ],
                        staticClass: "form-control min-w-100",
                        attrs: { id: "alert-select-criticality" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.criticality = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "", disabled: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "common.alerts.select_criticality_level_placeholder"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "CRITICAL" } }, [
                          _vm._v(_vm._s(_vm.$t("common.alerts.critical"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "HIGH" } }, [
                          _vm._v(_vm._s(_vm.$t("common.alerts.high"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "MEDIUM" } }, [
                          _vm._v(_vm._s(_vm.$t("common.alerts.medium"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "LOW" } }, [
                          _vm._v(_vm._s(_vm.$t("common.alerts.low"))),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "filter-item-action mb-5",
                    attrs: { sm: "6", lg: "3", cols: "12" },
                  },
                  [
                    _c("label", { attrs: { for: "alert-select-status" } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("common.alerts.status")) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.status,
                            expression: "status",
                          },
                        ],
                        staticClass: "form-control min-w-100",
                        attrs: { id: "alert-select-status" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.status = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "", disabled: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("common.alerts.select_status_placeholder")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "0" } }, [
                          _vm._v(_vm._s(_vm.$t("common.alerts.status_solved"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "1" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("common.alerts.status_on_going"))
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.displayFilter
              ? _c(
                  "b-row",
                  { staticClass: "justify-content-end" },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "mt-4 mb-5",
                        attrs: { sm: "4", lg: "2", cols: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mr-3",
                            attrs: { size: "sm" },
                            on: { click: _vm.clearFilterFields },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("filter.clr_fltr_field")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "mt-4 mb-5",
                        attrs: { sm: "4", lg: "2", cols: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn",
                            attrs: { size: "sm" },
                            on: { click: _vm.onRefresh },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("common.srch")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "mb-5" },
              [
                _c("b-col", [
                  _c(
                    "div",
                    { staticStyle: { overflow: "auto" } },
                    [
                      _vm.activateSpinner
                        ? _c("spinner")
                        : _vm.alertsHistoryList.length
                        ? _c("b-table", {
                            staticClass: "mt-3 table-striped",
                            attrs: {
                              responsive: "",
                              items: _vm.alertsHistoryList,
                              fields: _vm.alertsHistoryFields,
                              "sort-by": _vm.sortBy,
                              "sort-desc": _vm.sortDir,
                            },
                            on: {
                              "update:sortBy": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sort-by": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sortDesc": function ($event) {
                                _vm.sortDir = $event
                              },
                              "update:sort-desc": function ($event) {
                                _vm.sortDir = $event
                              },
                              "head-clicked": _vm.sortTable,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(MetricsKey)",
                                fn: function (data) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "common.monitoring.key." +
                                              data.value
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(ThresholdStatus)",
                                fn: function (data) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "common.alerts.threshold_status_value." +
                                              data.value
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(DateStart)",
                                fn: function (data) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.getDate(data.value))),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(DateEnd)",
                                fn: function (data) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.getDate(data.value))),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(Criticality)",
                                fn: function (data) {
                                  return [
                                    _vm.translateCriticalityFromDatabase(
                                      data.value
                                    ) == "LOW"
                                      ? _c("i", {
                                          staticClass:
                                            "fa-solid fa-circle color-light-blue",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.translateCriticalityFromDatabase(
                                      data.value
                                    ) == "MEDIUM"
                                      ? _c("i", {
                                          staticClass:
                                            "fa-solid fa-circle color-yellow",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.translateCriticalityFromDatabase(
                                      data.value
                                    ) == "HIGH"
                                      ? _c("i", {
                                          staticClass:
                                            "fa-solid fa-circle color-orange",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.translateCriticalityFromDatabase(
                                      data.value
                                    ) == "CRITICAL"
                                      ? _c("i", {
                                          staticClass:
                                            "fa-solid fa-circle color-red",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "common.alerts." +
                                              _vm.translateCriticalityFromDatabase(
                                                data.value
                                              )
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(status)",
                                fn: function (data) {
                                  return [
                                    data.value == 0
                                      ? _c("i", {
                                          staticClass:
                                            "fa-regular fa-circle-check color-lime-green",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.value == 1
                                      ? _c("i", {
                                          staticClass:
                                            "fa-regular fa-circle-xmark text-danger",
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          })
                        : _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              _c("span", { staticClass: "noResult" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.no_result")) +
                                    "\n              "
                                ),
                              ]),
                            ]
                          ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "mt-5" },
              [
                _c(
                  "b-col",
                  [
                    _c("cm-pagination", {
                      attrs: {
                        maxResultsByPage: _vm.paginationObject.maxResults,
                        firstIndex: _vm.paginationObject.firstIndex,
                        nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                        refreshEvent: _vm.paginationObject.refresh,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }